module.exports = __webpack_public_path__ + "img/weed_weedcashntwk.505f8c1.png";